import styled from "styled-components"
import theme from '../../styles/theme';
import Menu from "../../components/backoffice/common/Menu";
import Navigator from "../../components/backoffice/common/Navigator";
import { useState } from 'react';


const MainWrap = styled.div`
    width: 100%;
    height: 100vh;
    background: ${theme.color.white[100]};
    display:grid;
    grid-template-columns: ${(props)=>props.open ? '200px' : '0px'} auto;
    transition: ${theme.windowSize.drawerTransition};
`;

const MainBody = styled.div`
    overflow: auto;
`;

const AdminMainTemplate = ({target, naviInfo}) => {

    const [menuOpen, setMenuOpen] = useState(true);
    return (
        <MainWrap open={menuOpen}>
            <Menu open={menuOpen}/>
            <MainBody open={menuOpen}>
                <Navigator open={menuOpen} setOpen={setMenuOpen} naviInfo={naviInfo} />
                <div style={{padding:'0.25rem'}} />
                {target}
                <div style={{padding:'1rem'}} />
            </MainBody>

        </MainWrap>
    )

}

export default AdminMainTemplate;